<template>
    <div
      @getFile="getFile"
    >
    <a-input
      type="text"
      id="file_package"
      name="file"
      placeholder="请输入文件夹名"
    >
    </a-input>

    <a-input
      type="text"
      id="file_name"
      name="file"
      placeholder="请输入文件名"
    >
    </a-input>
  </div>
</template>

<script>
import { getFastDFSToken, saveFileUrl } from '@/api/file'
import { axios } from '@/utils/request'
import { fn } from 'moment'

export default {
    name: 'UploadFile',
    data () {
    return {
      file_package: '',
      file_name: '',
    }
  },
  created () {
    
  },
  methods: {
    getFile() {
      this.file_package = document.getElementById("file_package").value
      this.file_name = document.getElementById("file_name").value
    }
    /*
    handleChangeFiles (file_package) {
      debugger
      this.file_package = file_package.data
      this.$emit('upload', this.file_package)
    },
    
    handleChangeFile (file_name) {
      this.file_name = file_name.data
      this.$emit('upload', this.file_name)
    },
    */
  }
}
</script>

<style scoped>

</style>